import { createContext, useContext } from "react";

export const AuthContext = createContext({
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
  scopes: [],
});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const getAuthUser = (decrypt) => {
  const ctx = localStorage.getItem("ctx");
  if (!ctx) {
    return {
      isAuthenticated: false,
    };
  }
  return decrypt(ctx);
};
